"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = void 0;
const react_1 = __importDefault(require("react"));
const Theme_1 = require("../../Theme/Theme");
const Icon_1 = __importDefault(require("../Icon/Icon"));
const ChipContainer = Theme_1.styled.div `
  max-height: ${(props) => {
    if (props.variant === 'small') {
        return '24px';
    }
    return '32px';
}};
  padding: ${(props) => {
    if (props.variant === 'small') {
        return '4px 8px';
    }
    return '8px 16px';
}};
  border-radius: ${(props) => {
    if (props.variant === 'small') {
        return '24px';
    }
    return '32px';
}};
  opacity: ${(props) => (props.state === 'disabled' ? 0.5 : 1)};
  background-color: ${(props) => props.backgroundColor || props.theme.colors.gray[30]};
  color: ${(props) => props.theme.colors.gray[90]};
  font-size: 14px;
  font-family: ${(props) => props.theme.font.family.proximaNova};
  font-weight: ${(props) => props.state === 'selected' ? props.theme.font.weight.bold : null};
  cursor: ${(props) => props.state !== 'disabled' && props.onClick && 'pointer'};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  user-select: none;
  white-space: nowrap;
`;
const LeftIconContainer = Theme_1.styled.div `
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const RightIconContainer = Theme_1.styled.div `
  margin-left: 16px;
  display: flex;
`;
const getIcon = (icon) => {
    if (typeof icon === 'string') {
        return (react_1.default.createElement(LeftIconContainer, null,
            react_1.default.createElement(Icon_1.default, { icon: icon, size: "18" })));
    }
    return icon;
};
exports.Chip = (_a) => {
    var { onRemoveClick } = _a, props = __rest(_a, ["onRemoveClick"]);
    return (react_1.default.createElement(ChipContainer, Object.assign({}, props),
        props.leftIcon && getIcon(props.leftIcon),
        react_1.default.createElement("span", null, props.label),
        props.isRemovable && (react_1.default.createElement(RightIconContainer, null,
            react_1.default.createElement(Icon_1.default, { icon: "closeGrey", size: "14", onClick: (e) => onRemoveClick && onRemoveClick(e, props.label) })))));
};
exports.default = exports.Chip;
//# sourceMappingURL=Chip.js.map